import SplitPane from "react-split-pane";
// @ts-ignore
import Pane from "react-split-pane/lib/Pane";
import { useSplitContainerContext } from "../../../context/SplitContainerContext";
import { debounce } from "../../../utils/sharedUtil";
import PaneCollapseToggle from "./PaneCollapseToggle";
import styles from "./SplitContainer.module.css";

type SplitContainerProps = {
  type: "vertical" | "horizontal";
  className?: string;
  isResize?: boolean;
  onDragEnd?: (sizes: string[]) => void;
  onTogglePane?: () => void;
};

const SplitContainer = ({
  type,
  className,
  isResize,
  onDragEnd,
  onTogglePane,
}: SplitContainerProps) => {
  const {
    state: { panesState },
    actions: { togglePane },
  } = useSplitContainerContext();

  const togglePaneHandler = (id: string) => {
    if (onTogglePane) onTogglePane();
    togglePane(id);
  };

  const displayPanes = panesState.panes.map((p) => {
    const minSize =
      p.minSize !== null && p.minSize !== undefined
        ? `${p.minSize}%`
        : undefined;
    const maxSize =
      p.maxSize !== null && p.maxSize !== undefined
        ? `${p.maxSize}%`
        : undefined;
    const initialSize =
      p.initialSize !== null && p.initialSize !== undefined
        ? `${p.initialSize}%`
        : undefined;

    const pane = (
      <Pane
        className={`${styles.pane} ${p.isOpen ? styles.opened : ""}`}
        key={p.id}
        initialSize={initialSize}
        minSize={minSize}
        maxSize={
          p.isOpen ? maxSize : panesState.openTabId ? minSize : initialSize
        }
      >
        {p.showToggle && (
          <PaneCollapseToggle
            position={p.togglePosition ?? "right"}
            paneId={p.id}
            onToggle={togglePaneHandler}
            disabled={!p.isCollapsible}
            isOpen={p.isOpen}
          />
        )}
        {p.content ?? null}
      </Pane>
    );

    return pane;
  });

  const dragEndHandler = onDragEnd ? debounce(onDragEnd, 300) : null;

  const panesSizeChangeHandler = (size: string[]) => {
    if (dragEndHandler) dragEndHandler(size);
  };

  return (
    <SplitPane
      // @ts-ignore
      onChange={panesSizeChangeHandler}
      className={`${styles.container} ${className ?? ""} ${
        !isResize ? styles.disableResize : ""
      }`}
      split={type ?? "vertical"}
      allowResize={isResize}
    >
      {displayPanes}
    </SplitPane>
  );
};

export default SplitContainer;
